import {FunctionalModal} from "./FunctionalModal";
import Swot from "../swot/Swot";
import React from "react";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import ExitButton from "../buttons/ExitButton";

const SwotModal = ({setIsOpenModal, entity, name}) => {

    const closeUpdate = () => {
        setIsOpenModal(false)
    }

    const returnSwot = () => {
        return (
            <Modal>
                <FirstSection>
                    <h1> {name}</h1>
                    <ExitButton closeUpdate={closeUpdate}/>
                </FirstSection>
                <Swot entity={entity}/>
            </Modal>
        )

    }
    return (
        <FunctionalModal component={returnSwot()} setOpen={setIsOpenModal}/>
    )
}


const Modal = styled(BaseModal)`
  width: 90%;
  height: fit-content;
  @media (min-width: 1224px) {
    width: 900px;
    max-height: 750px;
  }
`
const FirstSection = styled.div`
  display: flex;

  h1 {
    flex-grow: 1;
    text-align: center;
  }

  .exit-btn {
    align-self: flex-start;
  }
`
export default SwotModal